module.exports = __webpack_public_path__ + "static/media/organic.d38cc221.png";